import { Tab, Tabs } from '@rossum/ui/material';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { MenuItem } from '../../components/NavBar/navigationStructure';
import { useVisibleMenuItems } from './useVisibleMenuItems';

/**
 * HeaderTabs component returns tabs that are generated from menu items from navigation structure
 * This lets you sync names and permissions for free.
 */

export const HeaderTabs = <T extends MenuItem>({
  menuItems,
  value,
  dataCy,
}: {
  menuItems: T[];
  value: T['name'];
  dataCy?: string;
}) => {
  const intl = useIntl();
  const { push } = useHistory();

  const { menuItems: tabs } = useVisibleMenuItems({
    menuItems,
  });

  return (
    <Tabs
      data-cy={dataCy}
      value={value}
      onChange={(_, newValue) => {
        const link = tabs.find(tab => tab.name === newValue)?.link;
        if (link) {
          push(link);
        }
      }}
    >
      {tabs.map(tab => (
        <Tab
          key={tab.name}
          label={intl.formatMessage({
            id: `components.appBar.menu.${tab.translationKey}`,
          })}
          data-cy={`tab-${tab.translationKey}`}
          value={tab.name}
        />
      ))}
    </Tabs>
  );
};
